import { render, staticRenderFns } from "./BoxesPerWorker.vue?vue&type=template&id=78a2c98e&lang=html&"
import script from "./BoxesPerWorker.vue?vue&type=script&lang=js&"
export * from "./BoxesPerWorker.vue?vue&type=script&lang=js&"
import style0 from "./BoxesPerWorker.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports